import React, { useEffect, useState } from 'react';
import Slab from '../../../../helpers/slab/Slab';
import Details from './Details';
import Summary from './Summary';
import Files from '../../../creates/file/Files';
import Audit from '../../generic/Audit';
import Get from '../../../../api/internal/Get';
import MaintenanceLogs from '../MaintenanceLogs';
import AssetTracking from '../AssetTracking';
import { useRoleAuthorization } from '../../../../hooks/useRoleAuthorization';
import { ADMIN_AUTHORIZED_ROLES } from '../../../../auth/AuthRoles';
import Admin from '../Admin';

function Truck({
  assetId,
  truckName,
  startPage,
}: {
  assetId: number;
  truckName: string;
  startPage?: string;
}) {
  const [currentPage, setCurrentPage] = useState();
  const [truckDataObject] = useState<TruckDataObject>({
    Audit: null,
    Admin: null,
    Details: null,
    Files: null,
    'Maintenance Logs': null,
    Summary: null,
    Tracking: null,
  });

  useEffect(() => {
    startPage ? HandlePageChange(startPage) : HandlePageChange('Summary');
  }, []);

  function HandlePageChange(params) {
    if (!truckDataObject[params] && pages[params].callerPath) {
      Get(pages[params].callerPath).then(response => {
        if (response) {
          truckDataObject[params] = response.data;
        }
        AssignPages();
        setCurrentPage(params);
      });
    } else {
      setCurrentPage(params);
    }
  }

  function RefreshPage(currentPage: string, additionalPages: string[]) {
    setCurrentPage(null);
    truckDataObject[currentPage] = null;
    additionalPages?.forEach(pageName => {
      truckDataObject[pageName] = null;
    });
    HandlePageChange(currentPage);
  }

  let pages = {};
  AssignPages();
  function AssignPages() {
    pages = {
      Summary: {
        content: (
          <Summary
            HandlePageChange={HandlePageChange}
            data={truckDataObject.Summary}
          />
        ),
        callerPath: `/Asset/GetTruckSummary/${assetId}`,
      },
      Details: {
        content: (
          <Details
            data={truckDataObject.Details}
            assetId={assetId}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/Asset/GetTruckDetails/${assetId}`,
      },
      'Maintenance Logs': {
        content: <MaintenanceLogs data={truckDataObject['Maintenance Logs']} />,
        callerPath: `/Asset/GetMaintenanceLogForAssetPanel/${assetId}`,
      },
      Files: {
        content: (
          <Files
            data={truckDataObject.Files}
            fileCategory={'asset'}
            categoryId={assetId}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/File/GetAllFiles/asset-${assetId}`,
      },
      Audit: {
        content: <Audit data={truckDataObject.Audit} />,
        callerPath: `/Asset/GetAssetAudit/${assetId}`,
      },
      Tracking: {
        content: (
          <AssetTracking
            data={truckDataObject.Tracking}
            assetId={assetId}
            loadId={null}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/Asset/GetAllLocationsForAsset/${assetId}`,
      },
    };
    if (useRoleAuthorization(ADMIN_AUTHORIZED_ROLES))
      pages['Admin'] = {
        content: (
          <Admin
            data={truckDataObject.Admin}
            assetId={assetId}
            RefreshPage={RefreshPage}
          />
        ),
        callerPath: `/Asset/GetAssetAdmin/${assetId}`,
      };
  }

  return (
    <Slab
      title={'Truck: ' + truckName}
      pages={pages}
      currentPage={currentPage}
      HandlePageChange={HandlePageChange}
      dataObject={truckDataObject}
    />
  );
}
export default Truck;
